import { post, get, baseURL } from "@/utils/request";

export const getDescendants = (params: any) => post(`/activity/getDescendants`, params);